import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'

const SuspendedModal = () => {
    const [is_open, setIsOpen] = useState(true);

    return (
        <Modal show={is_open} onHide={() => { setIsOpen(false) }} backdrop={"static"} centered>
            <Modal.Header closeButton>
                <Modal.Title className='fs-4'>Account restricted</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className='my-4 fs-5 text-log'>Your account access has been restricted. For assisstance please contact administrator.</p>
            </Modal.Body>
        </Modal>
    )
}

export default SuspendedModal